/* POWMIX · NutritionCalculator (sección nutrition-calculator).
   Seis preguntas y un resultado: geles por hora, plan gel a gel con minuto y sabor, agua y sodio orientativos
   y el kit (variante que cubre el total, con precio por gel). Sin dependencias.
   Regla (propuesta del Design System, a validar por un dietista-nutricionista):
   terminar 30 g/h, mejorar 60 g/h, competir 90 g/h; 90 g/h solo en salidas largas; salidas cortas 30 g/h;
   estómago sensible baja un escalón. Cafeína solo en el último tercio. Alergia a frutos de cáscara: sin producto. */
(function () {
  'use strict';

  function all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function one(s, c) { return (c || document).querySelector(s); }
  function list(s) { return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  function num(s) { var m = String(s == null ? '' : s).match(/\d+/); return m ? parseInt(m[0], 10) : 0; }
  function clock(min) { var h = Math.floor(min / 60), m = Math.round(min % 60); if (m === 60) { h += 1; m = 0; } return h + ':' + (m < 10 ? '0' : '') + m; }
  function money(cents, fmt) {
    fmt = fmt || '{{amount_with_comma_separator}} €';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), kind = m ? m[1] : 'amount';
    var noDec = kind.indexOf('no_decimals') > -1;
    var comma = kind.indexOf('comma') > -1 || kind.indexOf('space') > -1;
    var n = (cents / 100).toFixed(noDec ? 0 : 2).split('.');
    var th = kind.indexOf('space') > -1 ? ' ' : (kind.indexOf('apostrophe') > -1 ? "'" : (comma ? '.' : ','));
    var whole = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, whole + (n[1] ? (comma ? ',' : '.') + n[1] : '')).replace(/<[^>]*>/g, '');
  }

  /* Geles por hora (1, 2 o 3) a partir del objetivo, la duración y el estómago. */
  function gelsPerHour(a, minutes, cfg) {
    var g = { terminar: 1, mejorar: 2, competir: 3 }[a.goal] || 2;
    if (minutes < cfg.longMinutes) g = Math.min(g, 2);
    if (minutes < cfg.shortMinutes) g = Math.min(g, 1);
    if (a.stomach === 'menudo') g = Math.max(1, g - 1);
    return g;
  }

  /* Minutos de cada toma: repartidas a intervalos iguales, la primera a mitad del primer intervalo. */
  function schedule(gph, minutes) {
    var interval = 60 / gph, marks = [];
    for (var t = interval / 2; t < minutes; t += interval) marks.push(Math.round(t));
    if (!marks.length) marks.push(Math.round(Math.min(minutes / 2, 30)));
    return { interval: interval, marks: marks };
  }

  /* Kit: el pack más pequeño que cubre los geles; si no llega el mayor, varios del mayor más el resto. */
  function kitLines(need, packs) {
    packs = packs.slice().sort(function (x, y) { return x - y; });
    if (!packs.length) return [];
    var max = packs[packs.length - 1], lines = [], rest = need;
    function smallest(n) { for (var i = 0; i < packs.length; i++) { if (packs[i] >= n) return packs[i]; } return max; }
    if (need > max) { lines.push({ gels: max, count: Math.floor(need / max) }); rest = need - lines[0].count * max; }
    if (rest > 0) {
      var sp = smallest(rest);
      if (lines.length && sp === max) lines[0].count += 1; else lines.push({ gels: sp, count: 1 });
    }
    return lines;
  }

  /* Agua orientativa por hora según temperatura y sudoración (rangos prudentes, beber según la sed). */
  function water(a) {
    var s = ({ frio: 0, templado: 1, calor: 2 }[a.weather] || 1) + ({ poco: 0, normal: 1, mucho: 2 }[a.sweat] || 1);
    return [[400, 500], [400, 500], [500, 650], [600, 750], [700, 800]][s];
  }

  function init(root) {
    if (root.__pmNc) return;
    root.__pmNc = true;
    var cfg;
    try { cfg = JSON.parse(one('[data-nc-config]', root).textContent); } catch (e) { return; }
    ['carbs', 'sodium', 'caffeine', 'longMinutes', 'shortMinutes', 'defaultMinutes', 'defaultSessions'].forEach(function (k) { cfg[k] = Number(cfg[k]) || 0; });
    cfg.carbs = cfg.carbs || 30; cfg.sodium = cfg.sodium || 300;
    cfg.defaultMinutes = cfg.defaultMinutes || 180; cfg.defaultSessions = cfg.defaultSessions || 4;
    var plain = list(cfg.plainFlavors), caff = list(cfg.caffFlavors);
    var variants = (cfg.variants || []).map(function (v) {
      return { id: v.id, flavor: String(v.flavor || ''), gels: num(v.qty), price: v.price, compare: v.compare || 0, available: v.available !== false, image: v.image || null };
    }).filter(function (v) { return v.gels > 0; });
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var steps = all('[data-nc-step]', root);
    var last = steps.length - 1;
    var allergyStep = steps.indexOf(one('[data-allergy-step]', root));
    var send = one('[data-nc-send]', root);
    var state = { minutes: cfg.defaultMinutes, sessions: cfg.defaultSessions, rate: null, flavor: null, idx: 0, pointer: false, items: null };

    function answers() {
      var a = {};
      all('fieldset[data-q]', root).forEach(function (f) {
        var on = one('input:checked', f);
        a[f.getAttribute('data-q')] = on ? on.value : null;
      });
      return a;
    }
    function complete(step) { return all('fieldset[data-q]', step).every(function (f) { return !!one('input:checked', f); }); }
    function setText(sel, v) { all(sel, root).forEach(function (e) { e.textContent = v; }); }
    function paintOpts() { all('.pm-nc__opt', root).forEach(function (l) { var i = one('input', l); if (i) l.classList.toggle('is-checked', i.checked); }); }
    function drawDuration() {
      setText('[data-dur-h]', String(Math.floor(state.minutes / 60)));
      var m = state.minutes % 60;
      setText('[data-dur-m]', (m < 10 ? '0' : '') + m);
      all('[data-dur]', root).forEach(function (b) { b.setAttribute('aria-pressed', parseInt(b.getAttribute('data-dur'), 10) === state.minutes ? 'true' : 'false'); });
    }
    function allergic() { return answers().allergy === 'si'; }

    function show(i, focus) {
      var from = state.idx;
      state.idx = Math.max(0, Math.min(last, i));
      if (state.idx !== last) state.rate = null;
      steps.forEach(function (s, k) { s.hidden = k !== state.idx; });
      var bar = one('[data-nc-bar]', root), prog = one('[data-nc-progress]', root);
      if (bar) bar.style.width = Math.round(state.idx / last * 100) + '%';
      if (prog) { prog.setAttribute('aria-valuenow', String(state.idx + 1)); prog.setAttribute('aria-valuetext', state.idx === last ? 'Resultado' : 'Paso ' + (state.idx + 1) + ' de ' + last); }
      updateNav();
      if (state.idx === last) result();
      if (send && !send.hasAttribute('data-nc-posted')) send.hidden = state.idx !== last || allergic();
      if (focus && state.idx !== from) {
        if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: 'start' });
        var h = all('h1, h2', steps[state.idx]).filter(function (el) { return el.offsetParent !== null; })[0];
        if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      }
    }
    function updateNav() {
      var step = steps[state.idx], ok = complete(step);
      var prev = one('[data-nc-prev]', root), next = one('[data-nc-next]', root);
      if (prev) prev.disabled = state.idx === 0;
      if (next) next.disabled = state.idx === last || !ok;
      all('[data-nc-continue]', step).forEach(function (b) { b.disabled = !ok; });
    }
    function forward() {
      if (!complete(steps[state.idx])) return;
      /* la alergia corta el flujo: directo al resultado, sin recomendar producto */
      if (state.idx === allergyStep && allergic()) { show(last, true); return; }
      show(state.idx + 1, true);
    }
    function back() {
      if (state.idx === last && allergic() && allergyStep > -1) { show(allergyStep, true); return; }
      show(state.idx - 1, true);
    }

    function variant(flavor, gels) { return variants.filter(function (v) { return v.flavor === flavor && v.gels === gels; })[0]; }
    function flavorPool(a) {
      var have = function (f) { return variants.some(function (v) { return v.flavor === f; }); };
      var mixName = plain.concat(caff).filter(function (f) { return /mix/i.test(f); })[0];
      var pool = (a.caffeine === 'si' ? caff : a.caffeine === 'mix' && mixName ? [mixName] : plain.filter(function (f) { return !/mix/i.test(f); })).filter(have);
      if (!pool.length) pool = plain.concat(caff).filter(have);
      if (!pool.length) pool = variants.map(function (v) { return v.flavor; }).filter(function (f, i, arr) { return arr.indexOf(f) === i; });
      return pool;
    }
    /* Sabor de cada toma: cafeína solo en el último tercio si la ha elegido. */
    function gelFlavor(a, t, k) {
      var withCaff = a.caffeine === 'si' || (a.caffeine === 'mix' && t >= state.minutes * 2 / 3);
      if (withCaff) return { name: cfg.caffName, caff: true };
      if (state.flavor && state.flavor !== cfg.caffName && plain.indexOf(state.flavor) > -1) return { name: state.flavor, caff: false };
      var base = plain.length ? plain : [state.flavor || ''];
      return { name: base[k % base.length], caff: false };
    }

    function result() {
      var a = answers();
      var isAllergic = a.allergy === 'si';
      all('[data-nc-allergy]', root).forEach(function (e) { e.hidden = !isAllergic; });
      all('[data-nc-plan]', root).forEach(function (e) { e.hidden = isAllergic; });
      var live = one('[data-nc-live]', root);
      if (isAllergic) {
        state.items = null;
        if (live) live.textContent = 'Real Gel 30 no es para ti: lleva frutos de cáscara. No te recomendamos ningún kit.';
        return;
      }
      var pool = flavorPool(a);
      if (pool.indexOf(state.flavor) < 0) state.flavor = pool[0] || '';
      var gph = state.rate || gelsPerHour(a, state.minutes, cfg);
      var sc = schedule(gph, state.minutes);
      var total = sc.marks.length;
      var need = a.mode === 'entreno' ? total * state.sessions : total;
      var sportEl = one('fieldset[data-q="sport"] input:checked', root);
      var sport = sportEl ? sportEl.parentNode.textContent.trim().toLowerCase() : '';

      setText('[data-r="title"]', 'Tus geles' + (sport ? ' para ' + sport : '') + ' · ' + clock(state.minutes) + ' h');
      setText('[data-r="interval"]', gph === 1 ? 'Un gel cada hora' : 'Un gel cada ' + Math.round(sc.interval) + ' minutos');
      setText('[data-r="gph"]', String(gph));
      setText('[data-r="total"]', String(total));
      setText('[data-r="carbs"]', String(gph * cfg.carbs));
      setText('[data-r="sodium"]', String(gph * cfg.sodium));
      setText('[data-r="totals"]', total * cfg.carbs + ' g de carbohidratos y ' + total * cfg.sodium + ' mg de sodio en toda la salida.');
      all('[data-rate]', root).forEach(function (b) { b.setAttribute('aria-pressed', parseInt(b.getAttribute('data-rate'), 10) === gph ? 'true' : 'false'); });

      /* plan gel a gel */
      var tl = one('[data-r="timeline"]', root), caffFrom = null;
      if (tl) {
        tl.innerHTML = '';
        sc.marks.forEach(function (t, k) {
          var f = gelFlavor(a, t, k);
          if (f.caff && caffFrom === null) caffFrom = t;
          var li = document.createElement('li');
          if (f.caff) li.className = 'is-caff';
          var b = document.createElement('b'); b.textContent = clock(t);
          var s = document.createElement('span'); s.textContent = 'Gel ' + (k + 1) + ' · min ' + t;
          var sm = document.createElement('small'); sm.textContent = f.name + (f.caff ? ' (cafeína)' : '');
          li.appendChild(b); li.appendChild(s); li.appendChild(sm); tl.appendChild(li);
        });
      }

      /* agua y sodio */
      var w = water(a), hyd = [];
      hyd.push('Agua: entre ' + w[0] + ' y ' + w[1] + ' ml por hora, a sorbos y según la sed.');
      hyd.push('Sodio: tus geles aportan ' + gph * cfg.sodium + ' mg por hora (' + cfg.sodium + ' mg cada uno).');
      if (a.weather === 'calor' || a.sweat === 'mucho') hyd.push('Con calor o si sudas mucho pierdes más sal y agua: prueba en entrenos si necesitas sumar sales a tu bidón.');
      if (a.format === 'bidon' && cfg.bottle) hyd.push('En el bidón: ' + cfg.bottle + '.');
      fillList('[data-r="hydration"]', hyd);

      /* avisos según respuestas */
      var tips = [];
      if (gph === 3) tips.push('90 g por hora solo si has entrenado el intestino para tolerarlo. Si no, empieza por 60 g.');
      if (a.stomach === 'menudo') tips.push('Estómago sensible: hemos bajado un escalón. Empieza por este plan en entrenos y sube poco a poco.');
      if (a.stomach === 'veces') tips.push('Si a veces tienes molestias, prueba este plan en entrenos largos antes de competir.');
      if (a.caffeine === 'mix') {
        tips.push(cfg.caffName + ' aporta ' + cfg.caffeine + ' mg de cafeína por gel. La dejamos para el último tercio' + (caffFrom !== null ? ', a partir del minuto ' + caffFrom : '') + '. No recomendado para niños ni embarazadas.');
      }
      if (a.caffeine === 'si') tips.push('Con esta opción todos los geles llevan ' + cfg.caffeine + ' mg de cafeína. Vigila el total del día. No recomendado para niños ni embarazadas.');
      fillList('[data-r="tips"]', tips);

      /* kit */
      var fbox = one('[data-r="flavors"]', root);
      if (fbox) {
        fbox.innerHTML = '';
        pool.forEach(function (f) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'pm-chip pm-chip--sm' + (f === state.flavor ? ' is-selected' : '');
          b.setAttribute('aria-pressed', f === state.flavor ? 'true' : 'false');
          b.setAttribute('data-flavor', f); b.textContent = f; fbox.appendChild(b);
        });
        fbox.parentNode.hidden = pool.length < 2;
      }
      all('[data-nc-sessions]', root).forEach(function (e) { e.hidden = a.mode !== 'entreno'; });
      setText('[data-r="sessions"]', String(state.sessions));
      var packs = variants.filter(function (v) { return v.flavor === state.flavor; }).map(function (v) { return v.gels; });
      var lines = kitLines(need, packs);
      var items = lines.map(function (l) { return { line: l, v: variant(state.flavor, l.gels) }; });
      var ok = items.length && items.every(function (i) { return !!i.v; });
      /* Foto del kit: el packshot del pack mayor del sabor elegido (cambia al cambiar de sabor). */
      var kimg = one('[data-r="kit-img"]', root);
      var kv = items.length ? items.slice().sort(function (x, y) { return y.line.gels - x.line.gels; })[0].v : null;
      if (kimg && kv && kv.image) { kimg.src = kv.image; kimg.alt = 'REAL GEL 30 ' + state.flavor + ', pack de ' + kv.gels + ' geles'; }
      setText('[data-r="pack"]', state.flavor + ' · ' + lines.map(function (l) { return (l.count > 1 ? l.count + ' × ' : '') + l.gels + ' geles'; }).join(' + '));
      setText('[data-r="why"]', a.mode === 'entreno'
        ? 'Para ' + state.sessions + (state.sessions === 1 ? ' salida' : ' salidas') + ' como esta: ' + need + ' geles.'
        : 'Tu salida pide ' + need + (need === 1 ? ' gel.' : ' geles.'));
      var cta = one('[data-r="cta"]', root), price = '', compare = '', unit = '';
      setText('[data-r="cartmsg"]', '');
      if (ok) {
        var sum = 0, cmp = 0, gels = 0, soldOut = false;
        items.forEach(function (i) {
          sum += i.v.price * i.line.count; gels += i.line.gels * i.line.count;
          cmp += (i.v.compare > i.v.price ? i.v.compare : i.v.price) * i.line.count;
          if (!i.v.available) soldOut = true;
        });
        price = money(sum, cfg.money);
        compare = cmp > sum ? money(cmp, cfg.money) : '';
        unit = money(Math.round(sum / gels), cfg.money) + ' por gel';
        state.items = soldOut ? null : items.map(function (i) { return { id: i.v.id, quantity: i.line.count }; });
        if (cta) { cta.textContent = soldOut ? 'Agotado: ver otros packs' : 'Añadir mi kit'; cta.href = cfg.productUrl || '#'; }
      } else {
        state.items = null;
        if (cta) { cta.textContent = 'Ver Real Gel 30'; cta.href = cfg.productUrl || '#'; }
      }
      setText('[data-r="price"]', price);
      setText('[data-r="compare"]', compare);
      setText('[data-r="unit"]', unit);
      if (live) {
        live.textContent = 'Tu plan: ' + gph + (gph === 1 ? ' gel' : ' geles') + ' por hora, ' + total + ' en total, ' + gph * cfg.carbs + ' g de carbohidratos por hora. ' +
          'Kit recomendado: ' + one('[data-r="pack"]', root).textContent + (price ? ', ' + price + ', ' + unit : '') + '.';
      }
    }
    function fillList(sel, arr) {
      var box = one(sel, root); if (!box) return;
      box.innerHTML = '';
      arr.forEach(function (t) { var li = document.createElement('li'); li.textContent = t; box.appendChild(li); });
      box.hidden = !arr.length;
    }

    /* Añadir mi kit. Con carrito lateral: form oculto a /cart/add que intercepta cart-drawer.js
       (hace el fetch a /cart/add.js, refresca y abre el cajón). Sin carrito lateral: fetch a /cart/add.js y al carrito. */
    function addKit(cta) {
      var items = state.items;
      if (!items || !items.length) return false;
      var msg = one('[data-r="cartmsg"]', root);
      if (document.getElementById('CartDrawer')) {
        var f = document.createElement('form');
        f.method = 'post'; f.action = cartRoot + 'cart/add'; f.hidden = true;
        f.setAttribute('data-nc-cart', '');
        var field = function (n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = String(v); f.appendChild(i); };
        if (items.length === 1) { field('id', items[0].id); field('quantity', items[0].quantity); }
        else items.forEach(function (it, k) { field('items[' + k + '][id]', it.id); field('items[' + k + '][quantity]', it.quantity); });
        var btn = document.createElement('button'); btn.type = 'submit'; f.appendChild(btn);
        document.body.appendChild(f);
        if (f.requestSubmit) f.requestSubmit(btn); else btn.click();
        setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 15000);
        if (msg) msg.textContent = 'Añadiendo tu kit al carrito…';
        setTimeout(function () { if (msg) msg.textContent = ''; }, 4000);
        return true;
      }
      if (!window.fetch) return false;
      cta.setAttribute('aria-busy', 'true');
      if (msg) msg.textContent = 'Añadiendo tu kit al carrito…';
      fetch(cartRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (er) { throw er; }); return r.json(); })
        .then(function () { window.location.href = cfg.cartUrl || cartRoot + 'cart'; })
        .catch(function (er) {
          cta.removeAttribute('aria-busy');
          if (msg) msg.textContent = (er && (er.description || er.message)) || 'No se ha podido añadir al carrito. Prueba desde la ficha del producto.';
        });
      return true;
    }

    root.addEventListener('pointerdown', function () { state.pointer = true; });
    root.addEventListener('keydown', function () { state.pointer = false; });
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches('fieldset[data-q] input[type="radio"]')) return;
      paintOpts();
      var step = t.closest('[data-nc-step]');
      updateNav();
      /* paso de objetivo: avanza solo al tocar con el dedo o el ratón; con teclado se usa Continuar */
      if (step && step.hasAttribute('data-auto') && state.pointer && complete(step)) forward();
    });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, a');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-dur-step')) { state.minutes = Math.max(30, Math.min(24 * 60, state.minutes + parseInt(t.getAttribute('data-dur-step'), 10))); drawDuration(); return; }
      if (t.hasAttribute('data-dur')) { state.minutes = parseInt(t.getAttribute('data-dur'), 10); drawDuration(); return; }
      if (t.hasAttribute('data-nc-continue') || t.hasAttribute('data-nc-next')) { forward(); return; }
      if (t.hasAttribute('data-nc-prev')) { back(); return; }
      if (t.hasAttribute('data-nc-back-allergy')) { show(allergyStep, true); return; }
      if (t.hasAttribute('data-nc-reset')) {
        all('fieldset[data-q] input', root).forEach(function (i) { i.checked = false; });
        state.minutes = cfg.defaultMinutes; state.sessions = cfg.defaultSessions; state.rate = null; state.flavor = null;
        paintOpts(); drawDuration(); show(0, true); return;
      }
      if (t.hasAttribute('data-rate')) { state.rate = parseInt(t.getAttribute('data-rate'), 10); result(); return; }
      if (t.hasAttribute('data-flavor')) {
        state.flavor = t.getAttribute('data-flavor'); result();
        var chip = all('[data-flavor]', root).filter(function (b) { return b.getAttribute('data-flavor') === state.flavor; })[0];
        if (chip) chip.focus({ preventScroll: true });
        return;
      }
      if (t.hasAttribute('data-sessions-step')) { state.sessions = Math.max(1, Math.min(12, state.sessions + parseInt(t.getAttribute('data-sessions-step'), 10))); result(); return; }
      if (t.getAttribute('data-r') === 'cta') {
        if (t.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
        if (addKit(t)) e.preventDefault();
      }
    });

    paintOpts();
    drawDuration();
    show(0, false);
    /* tras enviar "Envíame mi plan" la página se recarga: llevamos la vista al aviso */
    if (send && send.hasAttribute('data-nc-posted')) send.scrollIntoView({ block: 'center' });
  }

  function boot() { all('[data-nc]').forEach(init); }

  /* Plan por email: alta en Klaviyo y evento "Plan de calculadora" con los datos del plan (API pública de cliente). */
  document.addEventListener('submit', function (ev) {
    var form = ev.target.closest && ev.target.closest('[data-nc-mail]');
    if (!form) return;
    ev.preventDefault();
    var root = form.closest('[data-nc]') || document;
    var msg = form.querySelector('[data-nc-mail-msg]');
    var email = (form.email.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { msg.textContent = 'Revisa el email.'; return; }
    if (!form.consent.checked) { msg.textContent = 'Marca la casilla para poder enviártelo.'; return; }
    var t = function (sel) { var e = root.querySelector(sel); return e ? e.textContent.trim().replace(/\s+/g, ' ') : ''; };
    var cta = root.querySelector('[data-r="cta"]');
    var plan = { kit: t('[data-r="pack"]'), resumen: t('[data-r="why"]'), totales: t('[data-r="totals"]'), pauta: t('[data-r="timeline"]').slice(0, 900), consejos: t('[data-r="tips"]').slice(0, 600), kit_url: cta ? cta.href : location.href };
    var key = form.getAttribute('data-key'), list = form.getAttribute('data-list');
    var headers = { 'Content-Type': 'application/json', revision: '2024-10-15' };
    var base = 'https://a.klaviyo.com/client/';
    var reqs = [fetch(base + 'events/?company_id=' + encodeURIComponent(key), { method: 'POST', headers: headers, body: JSON.stringify({ data: { type: 'event', attributes: { properties: plan, metric: { data: { type: 'metric', attributes: { name: 'Plan de calculadora' } } }, profile: { data: { type: 'profile', attributes: { email: email, properties: { ultimo_plan_kit: plan.kit } } } } } } }) })];
    if (list) reqs.push(fetch(base + 'subscriptions/?company_id=' + encodeURIComponent(key), { method: 'POST', headers: headers, body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: list } } } } }) }));
    msg.textContent = 'Enviando…';
    Promise.all(reqs).then(function (r) { msg.textContent = r.every(function (x) { return x.ok; }) ? 'Hecho: en unos minutos tienes tu plan en el email.' : 'No hemos podido enviarlo. Inténtalo de nuevo.'; })
      .catch(function () { msg.textContent = 'No hemos podido enviarlo. Inténtalo de nuevo.'; });
  });
  window.PMNutritionCalc = { init: init, gelsPerHour: gelsPerHour, schedule: schedule, kitLines: kitLines };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
